export const RESOURCE_UPDATE_NOTIF_ID = 'resource-update';
export const RESOURCE_BATCH_UPLOAD_NOTIF_ID = 'resource-batch-upload';
export const RESOURCE_DELETE_NOTIF_ID = 'resource-delete';
export const USER_UPDATE_NOTIF_ID = 'user-update';
export const SMART_ASSISTANT_CREATION_NOTIF_ID = 'smart-assistant-creation';
export const SMART_ASSISTANT_DELETE_NOTIF_ID = 'smart-assistant-delete';
export const OPEN_ROUTER_BYOK_UPDATE_NOTIF_ID = 'open-router-byok-update';
